import { motion, useScroll, useTransform } from "framer-motion";
import React, { useRef } from "react";
import "../../../App.css";

export default function Paragraph() {
    // Reference the outer wrapper to track its scroll
    const wrapperRef = useRef(null);

    // Scroll progress from when the wrapper hits center (start) to when it leaves center (end)
    const { scrollYProgress } = useScroll({
        target: wrapperRef,
        offset: ["start center", "end center"],
    });

    const paragraph =
        "Built by chess players for people who want to level up their play, Oakmate is a free browser extension that unlocks premium Game Review tools—plus exclusive features";
    // const paragraph =
    //     "Built by chess enthusiasts, for you. Oakmate is a free browser extension that unlocks premium game review tools—plus exclusive features";
    const words = paragraph.split(" ");

    return (
        <section ref={wrapperRef} className="containersuperwrapper">
            <div className="descriptionSection-Container">
                <p className="ExtensionDescription">
                    {words.map((word, i) => {
                        // Define each word's activation range based on its index
                        const start = i / words.length;
                        const end = (i + 1) / words.length;

                        return (
                            <Word
                                key={i}
                                progress={scrollYProgress}
                                range={[start, end]}
                            >
                                {word}
                            </Word>
                        );
                    })}
                </p>
            </div>
        </section>
    );
}

function Word({ children, progress, range }) {
    // Opacity goes from 0 to 1 over the word's range
    const opacity = useTransform(progress, range, [0, 1]);

    return (
        <span className="word">
            <span className="shadow">{children}</span>
            <motion.span style={{ opacity }}>{children}</motion.span>
        </span>
    );
}
